import React, { useEffect, useState } from "react";
import RightCustomModal from "../../Common/RightModal";
import AddShift from "../AddNewShift/AddShift"; // Import AddShift component
import { getSettingShift, shiftdeleteData } from "../../redux/Action";
import { useDispatch, useSelector } from "react-redux";
import Delete from "../../Common/Delete/Delete";
import SpinnerLoader from "../../components/common/spinnerloader/SpinnerLoader";
import Pagination from "../../Common/Pagination/Pagination";

const Shift = () => {
  const dispatch = useDispatch();
  const { allShiftList, deleteShiftlist, addShiftUser, updateShift } =
    useSelector((state) => state.main);
  const pageLoading = useSelector((state) => state.main.loading);

  const [openInviteMember, setOpenInviteMember] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState();
  const [updatedData, setUpdatedData] = useState({});
  const [status, setstatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getSettingShift(currentPage));
  }, [currentPage, deleteShiftlist, addShiftUser, updateShift]);

  const handleClose = () => {
    setOpenInviteMember(false);
    setUpdatedData({});
  };

  const onCloseModal = () => setOpen(false);

  const onOpenModal = (data) => {
    setSelectedUserId(data);
    setOpen(true);
  };

  const handleDelete = () => {
    dispatch(shiftdeleteData(selectedUserId?._id));
    onCloseModal();
  };

  const OnAddClickHandler = (key) => {
    setOpenInviteMember(true);
    setstatus(key);
  };

  const OnEditClickHandler = (data, key) => {
    setSelectedUserId(data?._id);
    setOpenInviteMember(true);
    setUpdatedData(data);
    setstatus(key);
  };

  const fields = [
    { label: "Shift Name", id: "name" },
    { label: "Shift Code", id: "shiftCode" },
    { label: "Start Time", id: "start_time" },
    { label: "End Time", id: "end_time" },
    { label: "Grace In Time", id: "graceInTime" },
    { label: "Grace Out Time", id: "graceOutTime" },
    { label: "Status", id: "status" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 pt-4">
          <div className="text_btn">
            <div className="company_name">
              <h1>Shift</h1>
            </div>
            <div className="btn_add">
              <button onClick={() => OnAddClickHandler("add")}>
                Add Shift
              </button>
            </div>
          </div>

          <div className="comp-table">
            <div className="table-responsive">
              {pageLoading ? (
                <SpinnerLoader />
              ) : (
                <table className="table table-bordered">
                  <thead>
                    <tr style={{ borderBottom: "1px solid #2C357D2E" }}>
                      {fields.map((field) => (
                        <th
                          key={field.name}
                          style={{
                            borderLeft: "none",
                            textAlign:
                              field.id === "status" ? "center" : "left",
                          }}
                        >
                          {field.label}
                        </th>
                      ))}
                      <th style={{ width: "18%", borderRight: "none" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {allShiftList?.data?.map((shift, index) => (
                      <tr key={index}>
                        {fields.map((field) => (
                          <td
                            key={field.id}
                            style={{
                              borderLeft: "none",
                              textAlign:
                                field.id === "status" ? "center" : "left",
                            }}
                          >
                            {field.id === "status" ? (
                              <span
                                style={{
                                  backgroundColor: shift[field.id]
                                    ? "#a2eddb40"
                                    : "#ff323240",
                                  color: shift[field.id]
                                    ? "#24e502"
                                    : "#ff3232",
                                  padding: "5px 15px",
                                  borderRadius: "8px",
                                  fontWeight: "300",
                                  display: "inline-block",
                                }}
                              >
                                {shift[field.id] ? "Active" : "Inactive"}
                              </span>
                            ) : (
                              shift[field.id] || "-"
                            )}
                          </td>
                        ))}
                        <td>
                          <span className="d-flex align-item-center justify-content-center gap-3">
                            <button
                              onClick={() => OnEditClickHandler(shift, "edit")}
                            >
                              Edit
                            </button>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      {openInviteMember && (
        <RightCustomModal
          isOpen={openInviteMember}
          onClose={handleClose}
          shouldCloseOnOutsideClick={true}
        >
          <AddShift
            onClose={handleClose}
            updatedData={updatedData}
            status={status}
          />
        </RightCustomModal>
      )}
      <>
        {open && (
          <Delete open={open} onClose={onCloseModal} onConfirm={handleDelete} />
        )}
      </>
      {console.log(allShiftList?.meta)}
      <Pagination listData={allShiftList?.meta} setPageData={setCurrentPage} />
    </>
  );
};

export default Shift;
